var currentaddressBookImportUploadId = 0;
var allStatesStr = 'AK,AL,AR,AS,AZ,CA,CO,CT,DE,DC,FL,GA,GU,HI,ID,IL,IN,IA,KS,KY,LA,ME,MP,MH,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PW,PA,PR,RI,SC,SD,TN,TX,UT,VT,VA,VI,WA,WV,WI,WY';
var allStatesArr = allStatesStr.split(',');
var isImportContactInit = false;
var activeAddressBookImportUploadId = null;
var addressBookImportUploadGridInit = false;
var importContactsGridInit = false;

function InitAddressBookImportDialog() {
	let initImportDialog = function () {
		jQuery('#addressBookImportDialog').dialog({
			title: "Import Contacts",
			modal: true,
			resizable: false,
			width: 700,
			dialogClass: 'addressBookImportDialog',
			open: function () {
				InitaddressBookImportUploadGrid();
			},
			close: function () {
				if (window.hadContactsImported) {
					window.hadContactsImported = false;
					RefreshGridMain();
				}
				importContactsGridInit = false;
			}
		});
	};
	if (!addressBookImportUploadGridInit) {
		PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, 'ContactImport', {
			isOldModule: true
		}), jQuery("body"), null, function () {
			initImportDialog();
		});
	}
	else {
		initImportDialog();
	}
}

var addressBookImportUploadGridXML = '';
var addressBookImportUploadGridMenu = null;
var addressBookImportUploadGrid = null;
var tbaddressBookImportUploadGrid = null;

function InitaddressBookImportUploadGrid() {
	PanteraScript.PanteraScriptService.GetGroupNameList(pjqSessionId, GetGroupNameListC, onScriptError);
	addressBookImportUploadGridMenu = new dhtmlXMenuObject('gridMenu');
	addressBookImportUploadGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	addressBookImportUploadGridMenu.renderAsContextMenu();
	addressBookImportUploadGridMenu.attachEvent("onClick", function (id, zoneId) {
		var rowId = zoneId.split('_')[0];
		if (id = 'viewEdit') {
			InitAddressBookImport(rowId);
		}
	});
	addressBookImportUploadGridMenu.loadXMLString(CreateGridMenuXMLString('upload|viewEdit'));

	addressBookImportUploadGrid = new dhtmlXGridObject('addressBookImportUploadGrid');
	addressBookImportUploadGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	addressBookImportUploadGrid.setSkin(pjqGridTheme);
	addressBookImportUploadGrid.enableAutoWidth(true);
	addressBookImportUploadGrid.enableAutoHeight(true);
	addressBookImportUploadGrid.enableContextMenu(addressBookImportUploadGridMenu);
	addressBookImportUploadGrid.setHeader("Filename, Uploaded By, Uploaded On");
	addressBookImportUploadGrid.setInitWidthsP("50,25,25");
	addressBookImportUploadGrid.setColSorting('int,str,str');
	addressBookImportUploadGrid.setColTypes('ro,ro,ro');
	addressBookImportUploadGrid.init();
	getImportUploads();
	addressBookImportUploadGrid.attachEvent("onRowSelect", function (id, ind) {
		tbaddressBookImportUploadGrid.enableItem('viewEdit');
		tbaddressBookImportUploadGrid.enableItem('delete');
	});
	addressBookImportUploadGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		InitAddressBookImport(rId);
	})
	addressBookImportUploadGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		return true;
	});

	tbaddressBookImportUploadGrid = new dhtmlXToolbarObject("addressBookImportUploadGridToolbar");
	tbaddressBookImportUploadGrid.setSkin("dhx_web");
	tbaddressBookImportUploadGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbaddressBookImportUploadGrid.addButton('viewEdit', 1, 'View/Edit', "edit.jpg", "editD.jpg");
	tbaddressBookImportUploadGrid.addSeparator('new_sep2', 2);
	tbaddressBookImportUploadGrid.addButton('upload', 3, 'Upload', "add_page.gif", "add_pageD.gif");
	tbaddressBookImportUploadGrid.addButton('delete', 3, 'Delete', "action_delete.gif", "action_deleteD.gif");
	tbaddressBookImportUploadGrid.addSpacer('delete');
	tbaddressBookImportUploadGrid.addButton('export', 5, 'Export Template', "Excel.jpg", "ExcelD.jpg");
	tbaddressBookImportUploadGrid.disableItem('viewEdit');
	tbaddressBookImportUploadGrid.disableItem('delete');
	tbaddressBookImportUploadGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'upload':
				InitAddressBookImportFileUpload();
				break;
			case 'viewEdit':
				InitAddressBookImport(parseInt(addressBookImportUploadGrid.getSelectedRowId()));
				break;
			case 'delete':
				ShowAddressBookImportDialog('Delete Import Document', 'Are you sure you want to delete this contact import document?', null, 'deleteImportUpload', null, false);
				break;
			case 'export':
				CreateAddressBookImportTemplate();
				break;
		}
	})
}

function getImportUploads() {
	new PJQ.ajax.Request({
		endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'contacts'
			},
			{
				endpoint: 'imports'
			}
		])
	}).get().done(_.bind(function (uploads) {
		let rows = [];
		_.each(uploads, function (upload) {
			rows.push({
				id: upload.contactImportUploadId,
				data: [
					upload.fileName,
					upload.uploadedBy,
					PJQ.helpers.dateHelpers.getDateString(new Date(upload.uploadedOn), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME)
				]
			});
		});
		addressBookImportUploadGrid.clearAll();
		addressBookImportUploadGrid.parse({rows: rows}, 'json');

		jQuery('.importAddressBookContactsButton').button();
		jQuery('#addressBookImportUploadGridContainer').show();
		if (addressBookImportUploadGrid.getRowsNum() == 0) {
			jQuery('#addressBookImportUploadsNone').show();
		}
		else {
			jQuery('#addressBookImportUploadsNone').hide();
			if (!addressBookImportUploadGridInit) {
				addressBookImportUploadGrid.setSizes();
			}
		}
		addressBookImportUploadGridInit = true;
	}, this));
}

function GetGroupNameListC(response) {
	settings.GroupNameList = jQuery.parseJSON(response);
}

function InitAddressBookImportFileUpload() {
	jQuery('#addressBookImportFileUploadDialog').dialog({
		title: "Upload Contact Import File",
		modal: true,
		resizable: false,
		width: "auto",
		dialogClass: 'addressBookImportFileUploadDialog',
		width: 400,
		open: function () {
			var myURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.FileUploadContext + '&sid=' + pjqSessionId;
			var addressBookImportFileUpload = jQuery('#addressBookImportFileUpload');
			addressBookImportFileUpload.attr('action', myURL);
			addressBookImportFileUpload.fileupload();
			addressBookImportFileUpload.fileupload('option', {
				autoUpload: true,
				url: myURL,
				dropZone: addressBookImportFileUpload
			});
			addressBookImportFileUpload.unbind('fileuploadstop');
			addressBookImportFileUpload.bind('fileuploadstop', function (e) {
				PanteraScript.PanteraScriptService.AddAddressBookImportUpload(pjqSessionId, settings.FileUploadContext, AddAddressBookImportUploadC, onScriptError);
			});
		},
		close: function (event, ui) {
			jQuery('#addressBookImportFileUploadDialog').find('.files').empty();
			jQuery('#addressBookImportFileUploadDialog').find('.dropnotice').show();
		},
		buttons: [{
			text: "Cancel",
			click: function () {
				jQuery(this).dialog('close');
			}
		}]
	});
}

function AddAddressBookImportUploadC() {
	getImportUploads();
	jQuery('#addressBookImportFileUploadDialog').dialog('close');
}

function InitAddressBookImport(addressBookImportUploadId) {
	activeAddressBookImportUploadId = addressBookImportUploadId;
	isImportContactInit = true;
	jQuery('#addressBookImportDialog').dialog('option', 'width', jQuery(window).width() - 100);
	jQuery('#addressBookImportUploadsGridContainer').slideUp('slow');
	jQuery('#importContactsGridContainer').slideDown('slow');
	jQuery('#importContactsGridLoading').show();
	InitImportContactsGrid(addressBookImportUploadId);
}

var importContactsGrid = null;
var tbImportContactsGrid = null;

function InitImportContactsGrid(addressBookImportUploadId) {
	importContactsGrid = new dhtmlXGridObject('importContactsGrid');
	importContactsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	importContactsGrid.setSkin(pjqGridTheme);
	//importContactsGrid.enableAutoWidth(true);
	importContactsGrid.enableAutoHeight(true);
	importContactsGrid.enableDragAndDrop(true);
	importContactsGrid.enableMultiselect(true);
	importContactsGrid.enablePaging(true, 25, 3, "importContactsGridPaging", true);
	importContactsGrid.setPagingSkin("toolbar", "dhx_web");
	importContactsGrid.setDragBehavior('complex');
	importContactsGrid.setDelimiter('|');
	importContactsGrid.load("/DesktopModules/PJQAddressBook/ImportContacts.aspx?sessionId=" + pjqSessionId + "&abuId=" + addressBookImportUploadId, "xml");
	importContactsGrid.init();
	importContactsGrid.attachEvent("onXLE", function (grid_obj, count) {
		importContactsGrid.deleteRow(importContactsGrid.getRowId(importContactsGrid.getRowsNum() - 1));
		PanteraScript.PanteraScriptService.GetAddressBookImportUpload(pjqSessionId, addressBookImportUploadId, GetAddressBookUploadC, onScriptError);
		PopulateComboBoxes();
		FormatImportContactGrid();
		for (var cr = 0; cr < importContactsGrid.getRowsNum(); cr++) {
			ValidateContactImportRow(importContactsGrid.getRowId(cr), null);
		}
		importContactsGridInit = true;
	});
	importContactsGrid.attachEvent("onRowSelect", function (id, ind) {
		//tbImportContactsGrid.enableItem('delete');
	});

	importContactsGrid.attachEvent("onEditCell", function (stage, id, ind) {
		var fieldValue = importContactsGrid.cells(id, ind).getValue();
		var colType = importContactsGrid.getColType(ind).toLowerCase();
		var colLabel = importContactsGrid.getColLabel(ind).toLowerCase();
		if (stage == 1 && colType == 'edn') {
			this.editor.obj.onkeypress = function (e) { //editor area
				var ValidChars = "0123456789.";
				if (ValidChars.indexOf((String.fromCharCode((e || event).keyCode))) != -1)
					return true; //allow
				return false; //deny
			}
		}
		else if (stage == 1 && colLabel == 'zip') {
			SetMaxLengthGridColumn(importContactsGrid, stage, ind, ind, 5);
		}
		else if (stage == 2) {
			ValidateContactImportRow(id, ind);
		}
		return true;
	});
	importContactsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		return true;
	});

	tbImportContactsGrid = new dhtmlXToolbarObject("importContactsGridToolbar");
	tbImportContactsGrid.setSkin("dhx_web");
	tbImportContactsGrid.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	tbImportContactsGrid.addButton('import', 2, 'Import Contacts', "new.gif", "new_dis.gif");
	//tbImportContactsGrid.addButton('add', 2, 'Add Contact', "new.gif", "new_dis.gif");
	tbImportContactsGrid.addSeparator('new_sep2', 3);
	tbImportContactsGrid.addButton('cancelImport', 4, 'Cancel Import', "Delete.png", "DeleteD.png");
	//tbImportContactsGrid.addButton('delete', 4, 'Delete Contact', "Delete.png", "DeleteD.png");
	//tbImportContactsGrid.addSpacer('delete');
	//tbImportContactsGrid.addButton('export', 5, 'Export Template', "Excel.jpg", "ExcelD.jpg");
	//tbImportContactsGrid.disableItem('delete');
	tbImportContactsGrid.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				var newRowId = importContactsGrid.getRowsNum() + 1;
				importContactsGrid.addRow(newRowId, "");
				setTimeout(function () {
					importContactsGrid.selectCell(importContactsGrid.getRowsNum() - 1, 0);
					importContactsGrid.editCell();
				}, 0)
				break;
			case 'delete':
				if (importContactsGrid.getSelectedRowId().indexOf('|') != -1) {
					var deleteArr = importContactsGrid.getSelectedRowId().split('|');
					for (var d = 0; d < deleteArr.length; d++) {
						importContactsGrid.deleteRow(deleteArr[d]);
					}
				}
				else {
					importContactsGrid.deleteRow(importContactsGrid.getSelectedRowId());
				}
				tbImportContactsGrid.disableItem('delete');
				break;
			case 'import':
				new PJQ.views.BaseModal({
					header: "Confirm Contact Import",
					isShowOkButton: true,
					okButtonText: 'Yes',
					isShowCancelButton: true,
					cancelButtonText: 'No',
					isVerticalCenter: true,
					body: '<div class="fs-16 text-muted">Are you sure you want to import these contacts?</div>',
					onOk: function () {
						window.contactImportLoaderModal = new PJQ.views.BaseModal({
							header: "Importing Contacts",
							isShowOkButton: false,
							isShowCancelButton: false,
							isVerticalCenter: true,
							body: '<div class="loader m-0a"></div><div class="fs-16 text-muted text-align-center mt-3">Contacts are importing, this may take a few minutes.</div>'
						});
						ImportAddressBookContacts();
					}
				});
				break;
			case 'cancelImport':
				jQuery('#addressBookImportDialog').dialog('option', 'width', 700)
				jQuery('#importContactsGridContainer').slideUp('slow');
				jQuery('#addressBookImportUploadsGridContainer').slideDown('slow');
				isImportContactInit = false;
				importContactsGridInit = false;
				break;
		}
	})
}

function ShowAddressBookImportDialog(titleText, message, iconClass, context, optionalVal) {
	if (iconClass) {
		jQuery('#dialog-message-icon').addClass(iconClass);
	}
	else {
		jQuery('#dialog-message-icon').addClass('ui-icon-info');
	}

	jQuery('#dialog-message-context').val(context);

	jQuery('#dlg-message-span').html(message);
	var buttonList = {
		Ok: function () {
			jQuery(this).dialog("close");
		}
	};
	if (context == 'deleteImportUpload') {
		jQuery('#dialog-message-icon').css('margin', '0 7px 20px 0');
		buttonList = {
			Yes: function () {
				PanteraScript.PanteraScriptService.DeleteAddressBookImportUpload(pjqSessionId, parseInt(addressBookImportUploadGrid.getSelectedRowId()), DeleteAddressBookImportUploadC, onScriptError);
				jQuery(this).dialog("close");
			},
			No: function () {
				jQuery(this).dialog("close");
			}
		};
	}
	jQuery("#dialog-message").dialog({
		modal: true,
		title: titleText,
		buttons: buttonList,
		dialogClass: 'screeningDialog',
		close: function () {
		}
	});
}

function DeleteAddressBookImportUploadC(response) {
	addressBookImportUploadGrid.deleteRow(addressBookImportUploadGrid.getSelectedRowId());
	tbaddressBookImportUploadGrid.disableItem('viewEdit');
	tbaddressBookImportUploadGrid.disableItem('delete');
}

function GetAddressBookUploadC(response) {
	var srResult = jQuery.parseJSON(response);
	var processedRows = [];
	if (srResult.ProcessedRows.length > 0) {
		processedRows = srResult.ProcessedRows.split('|');
		for (var pr = 0; pr < processedRows.length; pr++) {
			importContactsGrid.deleteRow(processedRows[pr]);
		}
	}
	if (importContactsGrid.getRowsNum() == 0) {
		jQuery('#addressBookImportDialog').dialog('option', 'width', 700);
		jQuery('#addressBookImportUploadsGridContainer').slideDown('slow');
		jQuery('#importContactsGridContainer').slideUp('slow');
		jQuery('#importContactsGridLoading').hide();
		isImportContactInit = false;
		if (processedRows.length > 0) {
			ShowAddressBookImportDialog('Contacts Already Imported', 'All contacts on this document have already been imported.', null, 'default', null);
		}
		else {
			PanteraScript.PanteraScriptService.UpdateAddressBookImportUploadProcessedRows(pjqSessionId, activeAddressBookImportUploadId, '', true, function () {
				getImportUploads();
			}, onScriptError);
			ShowAddressBookImportDialog('No Contacts to Import', 'No contacts were found in the selected document.', null, 'default', null);
		}
	}
	jQuery('#importContactsGridLoading').hide();
	importContactsGrid.setSizes();
	jQuery('#importContactsGrid').height(jQuery('#importContactsGrid').height() + 20);
	jQuery('#importContactsGrid').find('.objbox').height(jQuery('#importContactsGrid').find('.objbox').height() + 20);
}

function ValidateContactImportRow(id, ind) {
	var colType = '';
	var colLabel = '';
	var gridCell = null;
	var fieldValue = '';
	var isSave = true;
	var isFaxError = false;
	var isEmailError = false;
	if (ind != null) {
		colLabel = importContactsGrid.getColLabel(ind).toLowerCase();
		fieldValue = importContactsGrid.cells(id, ind).getValue();
		var colLabel = importContactsGrid.getColLabel(ind).toLowerCase();
		if (colLabel == 'phone' || colLabel == 'fax' || colLabel == 'cell') {
			importContactsGrid.cells(id, ind).setValue(FormatPhoneHelper(fieldValue));
		}
	}
	for (var c = 0; c < importContactsGrid.getColumnsNum(); c++) {
		colType = importContactsGrid.getColType(c).toLowerCase();
		colLabel = importContactsGrid.getColLabel(c).toLowerCase();
		gridCell = importContactsGrid.cells(id, c);
		fieldValue = gridCell.getValue();
		var isError = ValidateContactImportCell(colType, colLabel, fieldValue, gridCell);
		if (colLabel == 'fax' && isError) {
			isFaxError = true;
			if (isFaxError && isEmailError)
				isError = true;
			else
				isError = false;
		}
		else if (colLabel == 'email' && isError) {
			isEmailError = true;
			if (isFaxError && isEmailError)
				isError = true;
			else
				isError = false;
		}
		if (isError) {
			importContactsGrid.setCellTextStyle(id, c, 'background:red;');
		}
		else {
			importContactsGrid.setCellTextStyle(id, c, 'background:;');
		}
	}
	return isSave;
}

function ValidateContactImportCell(colType, colLabel, fieldValue, cell) {
	var isError = false;
	switch (colType) {
		case 'edtxt':
			if (colLabel == 'company name' || colLabel == 'fax') {
				if (fieldValue.trim().length == 0) {
					isError = true;
				}
			}
			else if (colLabel == 'postal code') {
				if (!PJQ.helpers.validators.validateZip(fieldValue)) {
					isError = true;
				}
			}
			else if (colLabel == 'email') {
				if (!PJQ.helpers.validators.validateEmail(fieldValue, true).success) {
					isError = true;
				}
			}
			break;
		case 'edn':
			if (fieldValue * 1 != fieldValue) {
				isError = true;
			}
			break;
		case 'clist':
			if (colLabel == 'groups' && fieldValue.trim().length > 0) {
				fieldValue = fieldValue.toUpperCase();
				if (!importContactsGridInit)
					cell.setValue(fieldValue);
				var tempGroups = fieldValue.split(',');
				for (var i = 0; i < tempGroups.length; i++) {
					if (settings.GroupNameList.indexOf(tempGroups[i]) == -1) {
						isError = true;
					}
				}

			}
			break;
	}
	return isError;
}

function SetMaxLengthGridColumn(grid, stage, cellIndexToSet, currentCellIndex, maxLength) {
	if (stage == 1 && cellIndexToSet == currentCellIndex) {
		grid.editor.obj.onkeypress = function () {
			return grid.editor.obj.value.length < maxLength;
		}
	}
}

var importCountNotImportedNoInfo = 0,
	importedContactCount = 0,
	processedImportRows = '';

function ImportAddressBookContacts() {
	if (this.importContactCount == null)
		this.importContactCount = importContactsGrid.getRowsNum();

	if (this.unsavedRowIdList == null) {
		this.unsavedRowIdList = [];
		for (var i = 0; i < importContactsGrid.getRowsNum(); i++) {
			this.unsavedRowIdList.push(importContactsGrid.getRowId(i));
		}
	}

	if (unsavedRowIdList.length > 0) {
		var saveContacts = [];
		for (var i = 0; i < (this.unsavedRowIdList.length > 100 ? 100 : this.unsavedRowIdList.length); i++) {
			var companyName = '';
			var contactName = '';
			var contactTitle = '';
			var address1 = '';
			var address2 = '';
			var city = '';
			var state = '';
			var zip = '';
			var country = '';
			var phone = '';
			var extension = '';
			var fax = '';
			var cell = '';
			var email = '';
			var isUnion = false;
			var isNonUnion = false;
			var isPrevWage = false;
			var isPublicSector = false;
			var isPrivateSector = false;
			var isDBE = false;
			var isDVBE = false;
			var isSBE = false;
			var isSDVBE = false;
			var isWBE = false;
			var notes = '';
			var groupsString = '';
			var regionsString = '';
			var customFieldsString = "";
			var isImportFail = false;
			var rowId = this.unsavedRowIdList[i];
			for (var c = 0; c < importContactsGrid.getColumnsNum(); c++) {
				var colId = importContactsGrid.getColumnId(c);
				var colType = importContactsGrid.getColType(c).toLowerCase();
				var colLabel = importContactsGrid.getColLabel(c).toLowerCase();
				var gridCell = importContactsGrid.cells(rowId, c);
				var fieldValue = gridCell.getValue();
				var isError = ValidateContactImportCell(colType, colLabel, fieldValue, gridCell);
				if (isError && (colLabel == 'company name' || colLabel == 'contact name' || colLabel == 'email')) {
					//if company name or contact name is not validated do not import this contact
					importCountNotImportedNoInfo++;
					isImportFail = true;
				}
				else if (isError) {
					fieldValue = '';
				}
				if ((colId.indexOf("company_") != -1 || colId.indexOf("contact_") != -1) && fieldValue.length > 0) {
					var thisCustomFieldString = "";
					if (colType == 'combo' && importContactsGrid.getColumnCombo(c).getOptionByLabel(fieldValue) != null) {
						thisCustomFieldString = importContactsGrid.getColumnCombo(c).getOptionByLabel(fieldValue).value.toString();
					}
					else {
						thisCustomFieldString = fieldValue.toString();
					}

					if (thisCustomFieldString.length > 0) {
						thisCustomFieldString = (colId + "{|}" + thisCustomFieldString);
						if (customFieldsString.length > 0)
							customFieldsString += ("||||" + thisCustomFieldString);
						else
							customFieldsString = thisCustomFieldString;
					}
				}
				switch (c) {
					case 0:
						companyName = fieldValue;
						break;
					case 1:
						contactName = fieldValue;
						break;
					case 2:
						contactTitle = fieldValue;
						break;
					case 3:
						address1 = fieldValue;
						break;
					case 4:
						address2 = fieldValue;
						break;
					case 5:
						city = fieldValue;
						break;
					case 6:
						state = fieldValue;
						break;
					case 7:
						zip = fieldValue;
						break;
					case 8:
						country = fieldValue;
						break;
					case 9:
						phone = fieldValue;
						break;
					case 10:
						extension = fieldValue;
						break;
					case 11:
						fax = fieldValue.replace(/[^0-9.]/g, "");
						break;
					case 12:
						cell = fieldValue;
						break;
					case 13:
						email = fieldValue;
						break;
					case 14:
						isUnion = GetGridBoolValue(fieldValue);
						break;
					case 15:
						isNonUnion = GetGridBoolValue(fieldValue);
						break;
					case 16:
						isPrevWage = GetGridBoolValue(fieldValue);
						break;
					case 17:
						isPublicSector = GetGridBoolValue(fieldValue);
						break;
					case 18:
						isPrivateSector = GetGridBoolValue(fieldValue);
						break;
					case 19:
						isDBE = GetGridBoolValue(fieldValue);
						break;
					case 20:
						isDVBE = GetGridBoolValue(fieldValue);
						break;
					case 21:
						isMBE = GetGridBoolValue(fieldValue);
						break;
					case 22:
						isSBE = GetGridBoolValue(fieldValue);
						break;
					case 23:
						isSDVBE = GetGridBoolValue(fieldValue);
						break;
					case 24:
						isWBE = GetGridBoolValue(fieldValue);
						break;
					case 25:
						notes = fieldValue;
						break;
					case 26:
						groupsString = fieldValue;
						break;
					case 27:
						regionsString = fieldValue.toLowerCase();
						break;
				}
			}
			if (!isImportFail) {
				saveContacts.push({
					oldRowId: rowId,
					screeningRequestId: 0,
					companyName: companyName,
					contactTitle: contactTitle,
					contactName: contactName,
					address1: address1,
					address2: address2,
					city: city,
					stateProvince: state,
					postalCode: zip,
					country: country,
					phone: phone,
					extension: extension,
					fax: fax,
					cell: cell,
					email: email,
					isUnion: isUnion,
					isNonUnion: isNonUnion,
					isPrevWage: isPrevWage,
					isPublicSector: isPublicSector,
					isPrivateSector: isPrivateSector,
					isDBE: isDBE,
					isDVBE: isDVBE,
					isMBE: isMBE,
					isSBE: isSBE,
					isSDVBE: isSDVBE,
					isWBE: isWBE,
					notes: notes,
					groupsString: groupsString,
					regionsString: regionsString,
					customFieldString: customFieldsString
				});
			}
			else {
				this.unsavedRowIdList = _.without(this.unsavedRowIdList, rowId)
			}
		}

		let request = new PJQ.ajax.Request({
			endpoint: "/contact/ImportContacts",
			data: saveContacts
		});
		request.post().done(function (data) {
			AddImportAddressBookContactC(data);
		}).fail(function () {
		});
	}
}

function AddImportAddressBookContactC(importContactResult) {
	importedContactCount += importContactResult.length;
	for (var i = 0; i < importContactResult.length; i++) {
		processedImportRows += importContactResult[i] + '|';
		importContactsGrid.deleteRow(importContactResult[i]);
		var deleteIndex = this.unsavedRowIdList.indexOf(importContactResult[i].toString());
		if (deleteIndex > -1)
			this.unsavedRowIdList.splice(deleteIndex, 1);
	}

	if (this.unsavedRowIdList.length == 0) {
		this.unsavedRowIdList = null;
		this.importContactCount = null;
		if (importContactsGrid.getRowsNum() == 0) {
			PanteraScript.PanteraScriptService.UpdateAddressBookImportUploadProcessedRows(pjqSessionId, activeAddressBookImportUploadId, processedImportRows.length > 0 ? processedImportRows.substring(0, processedImportRows.length - 1) : '', true, UpdateAddressBookImportUploadProcessedC, onScriptError);
		}
		else if (processedImportRows.length > 0) {
			PanteraScript.PanteraScriptService.UpdateAddressBookImportUploadProcessedRows(pjqSessionId, activeAddressBookImportUploadId, processedImportRows, false, false, onScriptError);
		}
		var dgText = "";
		if (importedContactCount === 1) {
			dgText = '1 contact was imported into your address book.';
		}
		else {
			dgText = importedContactCount + ' contacts were imported into your address book.';
		}
		if (importCountNotImportedNoInfo > 0) {
			dgText += '<br />' + importCountNotImportedNoInfo + ' were not imported due to insufficient contact information.  Please review the contacts that were not imported in the grid and update the required information.';
		}
		if (window.contactImportLoaderModal != null) {
			window.contactImportLoaderModal.removeModal();
		}
		new PJQ.views.BaseModal({
			header: "Contacts Imported",
			isShowOkButton: true,
			isShowCancelButton: false,
			isVerticalCenter: true,
			body: '<div class="fs-16 text-muted">' + dgText + '</div>'
		});
		isImportContactInit = false;
		this.importContactCount = 0;
		importedContactCount = 0;
		importCountNotImportedNoInfo = 0;
		processedImportRows = '';
		window.hadContactsImported = true;
	}
	else {
		ImportAddressBookContacts();
	}
}

function UpdateAddressBookImportUploadProcessedC(response) {
	getImportUploads();
	jQuery('#addressBookImportDialog').dialog('option', 'width', 700);
	jQuery('#importContactsGridContainer').slideUp('slow');
	jQuery('#addressBookImportUploadsGridContainer').slideDown('slow');
}

function GetGridBoolValue(value) {
	return parseInt(value) == 0 ? false : true;
}

function PopulateComboBoxes() {
	for (var i = 0; i < importContactsGrid.getColumnsNum(); i++) {
		var colType = importContactsGrid.getColType(i).toLowerCase();
		if (colType == 'combo') {
			var colId = importContactsGrid.getColumnId(i);
			if (colId.indexOf('contact_') != -1) {
				colId = colId.replace('contact_', '');
				PanteraScript.PanteraScriptService.GetContactCustomFieldChoicesForCombo(pjqSessionId, colId, i, PopulateCustomFieldComboBoxesC, onScriptError);
			}
			else if (colId.indexOf('company_') != -1) {
				colId = colId.replace('company_', '');
				PanteraScript.PanteraScriptService.GetContactCompanyCustomFieldChoicesForCombo(pjqSessionId, colId, i, PopulateCustomFieldComboBoxesC, onScriptError);
			}
			else if (colId.indexOf('StateProvince')) {
				for (var s = 0; s < allStatesArr.length; s++) {
					importContactsGrid.getColumnCombo(i).addOption(allStatesArr[s], allStatesArr[s]);
				}
			}
			else if (colId.indexOf('Country')) {
				importContactsGrid.getColumnCombo(i).addOption('US', 'US');
				importContactsGrid.getColumnCombo(i).addOption('CA', 'CA');
			}
		}
		else if (colType == 'clist') {
			PopulateGroupComboLists(i);
		}
		else if (colType == 'clist2') {
			var colId = importContactsGrid.getColumnId(i);
			if (colId.indexOf('contact_') != -1) {
				colId = colId.replace('contact_', '');
				PanteraScript.PanteraScriptService.GetContactCustomFieldChoicesForCombo(pjqSessionId, colId, i, PopulateCustomFieldCList2C, onScriptError);
			}
			else if (colId.indexOf('company_') != -1) {
				colId = colId.replace('company_', '');
				PanteraScript.PanteraScriptService.GetContactCompanyCustomFieldChoicesForCombo(pjqSessionId, colId, i, PopulateCustomFieldCList2C, onScriptError);
			}
		}
	}
}

function PopulateGroupComboLists(index) {
	var tempComboArr = [];
	for (var i = 0; i < settings.GroupNameList.length; i++) {
		tempComboArr.push(settings.GroupNameList[i])
	}
	importContactsGrid.registerCList(index, tempComboArr);
}

function PopulateCustomFieldCList2C(response) {
	var comboResult = jQuery.parseJSON(response);
	var thisCombo = importContactsGrid.getColumnCombo(comboResult.ColumnIndex);
	var choices = [];
	for (var i = 0; i < comboResult.CustomFieldChoiceList.length; i++) {
		var choiceId = 0;
		if (comboResult.CustomFieldChoiceList[i].ContactCustomFieldChoiceId != null) {
			choiceId = comboResult.CustomFieldChoiceList[i].ContactCustomFieldChoiceId;
		}
		else if (comboResult.CustomFieldChoiceList[i].ContactCompanyCustomFieldChoiceId != null) {
			choiceId = comboResult.CustomFieldChoiceList[i].ContactCompanyCustomFieldChoiceId;
		}

		choices.push(choiceId.toString() + '|' + comboResult.CustomFieldChoiceList[i].ChoiceName);
	}
	// set in grid for this columnindex
	importContactsGrid.registerCList2(comboResult.ColumnIndex, choices.join('||'));

}

function PopulateCustomFieldComboBoxesC(response) {
	var comboResult = jQuery.parseJSON(response);
	var thisCombo = importContactsGrid.getColumnCombo(comboResult.ColumnIndex);
	var tempComboOuterArr = [];
	for (var i = 0; i < comboResult.CustomFieldChoiceList.length; i++) {
		var tempComboArr = [];
		if (comboResult.CustomFieldChoiceList[i].ContactCustomFieldChoiceId != null) {
			tempComboArr.push(comboResult.CustomFieldChoiceList[i].ContactCustomFieldChoiceId);
		}
		else if (comboResult.CustomFieldChoiceList[i].ContactCompanyCustomFieldChoiceId != null) {
			tempComboArr.push(comboResult.CustomFieldChoiceList[i].ContactCompanyCustomFieldChoiceId);
		}
		tempComboArr.push(comboResult.CustomFieldChoiceList[i].ChoiceName);
		if (tempComboArr.length > 0)
			tempComboOuterArr.push(tempComboArr);
	}
	thisCombo.addOption(tempComboOuterArr);
}

function FormatImportContactGrid() {
	for (var i = 0; i < importContactsGrid.getColumnsNum(); i++) {
		if (importContactsGrid.getColumnId(i).indexOf('fphone_') != -1) {
			for (var r = 0; r < importContactsGrid.getRowsNum(); r++) {
				importContactsGrid.cells2(r, i).setValue(FormatPhoneHelper(importContactsGrid.cells2(r, i).getValue()));
			}
		}
		else if (importContactsGrid.getColumnId(i).indexOf('fchoice_') != -1) {
			for (var r = 0; r < importContactsGrid.getRowsNum(); r++) {
				importContactsGrid.cells2(r, i).setValue(FormatPhoneHelper(importContactsGrid.cells2(r, i).getValue()));
			}
		}
	}
}

function CreateAddressBookImportTemplate() {
	PanteraScript.PanteraScriptService.GetAddressBookImportTemplate(pjqSessionId, 0, CreateAddressBookImportTemplateC, onScriptError);
}

function CreateAddressBookImportTemplateC(response) {
	PJQ.files.downloadFile(response, {
		isEndpoint: false
	})
}

function CreateGridMenuXMLString(optionList) {
	//Pass in all button names separated with a pipe
	var optsArr = [];
	if (optionList.indexOf('|') != -1) {
		optsArr = optionList.split('|');
	}
	else {
		optsArr.push(optionList);
	}
	var xmlResult = "<?xml version=\"1.0\"?>";
	xmlResult += "<menu>";
	for (var o = 0; o < optsArr.length; o++) {
		if (optsArr[o].toLowerCase() == 'add') {
			xmlResult += "<item id=\"add\" text=\"Add\">Add</item>";
		}
		else if (optsArr[o].toLowerCase() == 'edit') {
			xmlResult += "<item id=\"edit\" text=\"Edit\">Edit</item>";
		}
		else if (optsArr[o].toLowerCase() == 'view') {
			xmlResult += "<item id=\"view\" text=\"View\">View</item>";
		}
		else if (optsArr[o].toLowerCase() == 'delete') {
			xmlResult += "<item id=\"delete\" text=\"Delete\">Delete</item>";
		}
		else if (optsArr[o].toLowerCase() == 'viewedit') {
			xmlResult += "<item id=\"viewEdit\" text=\"View/Edit\">View/Edit</item>";
		}
		else if (optsArr[o].toLowerCase() == 'resend') {
			xmlResult += "<item id=\"resend\" text=\"Resend\">Resend</item>";
		}
		else if (optsArr[o].toLowerCase() == 'import') {
			xmlResult += "<item id=\"import\" text=\"Import\">Import</item>";
		}
	}
	xmlResult += "</menu>";
	return xmlResult;
}